/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAppointmentBaseResponse } from './GetAppointmentBaseResponse';
import {
    GetAppointmentBaseResponseFromJSON,
    GetAppointmentBaseResponseFromJSONTyped,
    GetAppointmentBaseResponseToJSON,
    GetAppointmentBaseResponseToJSONTyped,
} from './GetAppointmentBaseResponse';
import type { AppointmentRequestVariantId } from './AppointmentRequestVariantId';
import {
    AppointmentRequestVariantIdFromJSON,
    AppointmentRequestVariantIdFromJSONTyped,
    AppointmentRequestVariantIdToJSON,
    AppointmentRequestVariantIdToJSONTyped,
} from './AppointmentRequestVariantId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { GetTimeEntryTypeBaseResponse } from './GetTimeEntryTypeBaseResponse';
import {
    GetTimeEntryTypeBaseResponseFromJSON,
    GetTimeEntryTypeBaseResponseFromJSONTyped,
    GetTimeEntryTypeBaseResponseToJSON,
    GetTimeEntryTypeBaseResponseToJSONTyped,
} from './GetTimeEntryTypeBaseResponse';

/**
 * 
 * @export
 * @interface GetTimeEntryResponse
 */
export interface GetTimeEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryResponse
     */
    id: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTimeEntryResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof GetTimeEntryResponse
     */
    entryDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryResponse
     */
    clockIn: string;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryResponse
     */
    clockOut: string;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryResponse
     */
    remarks: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTimeEntryResponse
     */
    isApproved: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryResponse
     */
    approvedBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetTimeEntryResponse
     */
    approvedAt: Date | null;
    /**
     * 
     * @type {GetAppointmentBaseResponse}
     * @memberof GetTimeEntryResponse
     */
    appointmentId: GetAppointmentBaseResponse | null;
    /**
     * 
     * @type {Date}
     * @memberof GetTimeEntryResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTimeEntryResponse
     */
    updatedAt: Date | null;
    /**
     * 
     * @type {GetTimeEntryTypeBaseResponse}
     * @memberof GetTimeEntryResponse
     */
    timeEntryType: GetTimeEntryTypeBaseResponse | null;
    /**
     * 
     * @type {string}
     * @memberof GetTimeEntryResponse
     */
    reviewingByEmail?: string | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof GetTimeEntryResponse
     */
    appointmentBookingId?: AppointmentRequestVariantId | null;
}

/**
 * Check if a given object implements the GetTimeEntryResponse interface.
 */
export function instanceOfGetTimeEntryResponse(value: object): value is GetTimeEntryResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('entryDate' in value) || value['entryDate'] === undefined) return false;
    if (!('clockIn' in value) || value['clockIn'] === undefined) return false;
    if (!('clockOut' in value) || value['clockOut'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('isApproved' in value) || value['isApproved'] === undefined) return false;
    if (!('approvedBy' in value) || value['approvedBy'] === undefined) return false;
    if (!('approvedAt' in value) || value['approvedAt'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('timeEntryType' in value) || value['timeEntryType'] === undefined) return false;
    return true;
}

export function GetTimeEntryResponseFromJSON(json: any): GetTimeEntryResponse {
    return GetTimeEntryResponseFromJSONTyped(json, false);
}

export function GetTimeEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTimeEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'entryDate': (new Date(json['entryDate'])),
        'clockIn': json['clockIn'],
        'clockOut': json['clockOut'],
        'remarks': json['remarks'],
        'isApproved': json['isApproved'],
        'approvedBy': json['approvedBy'],
        'approvedAt': (json['approvedAt'] == null ? null : new Date(json['approvedAt'])),
        'appointmentId': GetAppointmentBaseResponseFromJSON(json['appointmentId']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
        'timeEntryType': GetTimeEntryTypeBaseResponseFromJSON(json['timeEntryType']),
        'reviewingByEmail': json['reviewingByEmail'] == null ? undefined : json['reviewingByEmail'],
        'appointmentBookingId': json['appointmentBookingId'] == null ? undefined : AppointmentRequestVariantIdFromJSON(json['appointmentBookingId']),
    };
}

export function GetTimeEntryResponseToJSON(json: any): GetTimeEntryResponse {
    return GetTimeEntryResponseToJSONTyped(json, false);
}

export function GetTimeEntryResponseToJSONTyped(value?: GetTimeEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'entryDate': value['entryDate'].toISOString().substring(0,10),
        'clockIn': value['clockIn'],
        'clockOut': value['clockOut'],
        'remarks': value['remarks'],
        'isApproved': value['isApproved'],
        'approvedBy': value['approvedBy'],
        'approvedAt': value['approvedAt'] == null ? value['approvedAt'] : value['approvedAt'].toISOString(),
        'appointmentId': GetAppointmentBaseResponseToJSON(value['appointmentId']),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'timeEntryType': GetTimeEntryTypeBaseResponseToJSON(value['timeEntryType']),
        'reviewingByEmail': value['reviewingByEmail'],
        'appointmentBookingId': AppointmentRequestVariantIdToJSON(value['appointmentBookingId']),
    };
}

